export default function TestStrips() {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M4 15.2852H10'
        stroke='#474646'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.92695 9.11676L7.37695 8.39476C7.71695 7.84876 8.47795 7.76176 8.93295 8.21676L11.043 10.3268C11.531 10.8148 11.39 11.6388 10.767 11.9358L9.97295 12.3148C9.59095 12.4978 9.13495 12.4188 8.83495 12.1198L7.06795 10.3528C6.73895 10.0238 6.68095 9.51176 6.92695 9.11676Z'
        stroke='#474646'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12 10.2852H12.443C14.652 10.2852 16.443 12.0762 16.443 14.2852C16.443 16.4942 14.652 18.2852 12.443 18.2852C10.581 18.2852 9.03098 17.0072 8.58398 15.2852'
        stroke='#474646'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.6424 7.64355C17.4304 8.56555 19.4434 11.1886 19.4434 14.2856C19.4434 18.1516 16.3094 21.2856 12.4434 21.2856C8.91744 21.2856 6.00944 18.6766 5.52344 15.2856'
        stroke='#474646'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8.35352 7.93245L11.7925 4.49345C12.1835 4.10245 12.8165 4.10245 13.2065 4.49345L14.7925 6.07945C15.1835 6.47045 15.1835 7.10345 14.7925 7.49345L11.3275 10.9584'
        stroke='#474646'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6 21.2852H19'
        stroke='#474646'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.9658 6.31947L16.2928 4.99247C16.6838 4.60147 16.6838 3.96847 16.2928 3.57847L15.7068 2.99247C15.3158 2.60147 14.6828 2.60147 14.2928 2.99247L12.9668 4.31847'
        stroke='#474646'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
